import get from "lodash/get";
import { connect } from "~/redux/connect";
import { getFilters, getFilterValues, getAllItemStateInfos } from "~/stateGetter";
import { presentAppliedFilterValuesObject } from "~/statePresenter";
import { settingsActionCreator } from "~/actions/settingsActions";

const mapStateToProps = (state, { modelId, name }) => {
    const filterValues = getFilterValues(state, modelId);
    return {
        filter: get(getFilters(state, modelId), name),
        active: (name in presentAppliedFilterValuesObject({
            ...getAllItemStateInfos(state, modelId),
            filterValues,
        })),
        filterValue: get(filterValues, name) ?? null,
    }
}


const mapDispatchToProps = (dispatch, { modelId, name }) => {
    return {
        onDelete: () => dispatch(settingsActionCreator(modelId).resetFieldValue(name, { created_at: null, remove_filter: true, })),
    }
}

const mergedProps = (stateprops, dispatchProps, ownProps) => {
    return {
        ...stateprops, ...dispatchProps, ...ownProps
    }
}

export const connectedFilterType = connect((state, { modelId, name }) => ({
    filterType: get(getFilters(state, modelId), name).type,
}));


export const connectedFilterChip = connect(mapStateToProps, mapDispatchToProps, mergedProps)